import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { About } from '../components/About';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-blue-200 selection:text-blue-900" data-id="element-224">
      <Header data-id="element-225" />
      <main data-id="element-226">
        <Hero data-id="element-227" />
        <Services data-id="element-228" />
        <About data-id="element-229" />
        <Contact data-id="element-230" />
      </main>
      <Footer data-id="element-231" />
    </div>;
}